import { jsx as _jsx } from "react/jsx-runtime";
import { EntityStatus } from '@dossierhq/core';
import { DropdownSelector, initializeMultipleSelectorState, reduceMultipleSelectorState, } from '@dossierhq/design';
import { StatusTag } from '../StatusTag/StatusTag.js';
export function initializeStatusSelectorState({ selectedIds, }) {
    const items = [
        { id: EntityStatus.draft },
        { id: EntityStatus.published },
        { id: EntityStatus.modified },
        { id: EntityStatus.withdrawn },
        { id: EntityStatus.archived },
    ];
    return initializeMultipleSelectorState({
        items,
        selectedIds,
    });
}
export const reduceStatusSelectorState = reduceMultipleSelectorState;
export function StatusSelector(props) {
    return (_jsx(DropdownSelector, { ...props, renderItem: (item) => _jsx(StatusTag, { status: item.id }) }));
}
//# sourceMappingURL=StatusSelector.js.map